<template>
  <div class="sidebar">
    <div class="sidebar-loading" v-if="isLoading">
      <loading-placeholder class="loading-placeholder-image"></loading-placeholder>
    </div>
    <div class="sidebar-wrapper" v-if="!isLoading">
      <div class="sidebar-header">
        <b-dropdown id="ddown1" class="site-dropdown" no-caret>
          <template slot="button-content">
            <span class="group-name">{{selectedGroupName}}
              <span>
                <down-icon class="down-caret"></down-icon>
              </span>
            </span>
          </template>
          <b-dropdown-item @click="selectGroup({groupID:'all'})">
            All Sites
          </b-dropdown-item>
          <b-dropdown-item @click="selectGroup(group)" v-for="group in groups" :key="group.groupID">
            {{group.name}}
          </b-dropdown-item>
        </b-dropdown>
        <span @click="openManageGroups($event)" class="groups-btn" v-b-tooltip.hover title="Manage groups">
          <group-icon class="icon-default groups"></group-icon>
        </span>
        <div class="search-container">
          <input type="text" class="search sites" v-model="searchText" placeholder="type to filter" name="" />
          <magnifier-icon class="lens-icon"></magnifier-icon>
        </div>
        <p class="site-selectors">Select:
          <a @click="selectAll(groups)">All</a>
          <a @click="selectNone(groups)">None</a>
          <label class="total-site-count float-right">
            <tick-icon class="icon-default tick"></tick-icon>
            <strong>{{selectedSitesCount}}</strong> {{ 'Site' | pluralize(selectedSitesCount)}} selected</label>
        </p>
      </div>
      <div class="sidebar-content" id="sidebarcontent">
        <div class="sidebar-site-list">
          <div v-for="site in sites" :key="site.siteID" class="site-item" v-if="sites.length!=0" v-bind:class="{active:popoverMap[site.siteID]}">
            <b-form-checkbox class="darkbg" :checked="site.selected" @change="toggleSite(site,$event)" size="md">
            </b-form-checkbox>

            <div class="site-name-wrapper" :id="'popover_'+site.siteID" @mouseenter="showPopover(site.siteID)" @mouseleave="hidePopover(site.siteID)">
              <img class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
              <span class="site-name" v-bind:class="{broken:site.connectionStatus ==='0',maintenance:site.connectionStatus ==='2'}" ref="button" variant="primary">
                {{site.name}}</span>
              <b-popover placement="right" boundary="viewport" :target="'popover_'+site.siteID" @show="setPopoverMap(site.siteID,true)" @hide="setPopoverMap(site.siteID,false)" no-fade>
                <div>
                  <site-info v-if="popoverMap[site.siteID]" :site="site" @action="processAction" @mouseenter.native="setContentHoverMap(site.siteID)" @mouseleave.native="closePopover(site.siteID)"></site-info>
                </div>
              </b-popover>
            </div>
          </div>
          <div v-if="sites.length==0">
            <empty-placeholder v-if="searchText.length>0" type="neutral" v-bind="placeholderProps"></empty-placeholder>
          </div>
        </div>
      </div>
    </div>

    <!-- <addsite v-if="!isLoading"></addsite> -->
    <edit-site ref="editsite" :site="currentSite"></edit-site>
    <server-info ref="serverinfo" :site="currentSite"></server-info>
    <maintenance-mode ref="maintanancemode" :site="currentSite"></maintenance-mode>
    <manage-groups ref="managegroups"></manage-groups>
    <remove-site ref="removesite" :site="currentSite"></remove-site>
    <readd-site ref="readdsite" :site="currentSite"></readd-site>
    <create-backup ref="createBackup" :siteId="currentSite.siteID"></create-backup>
  </div>
</template>

<script>
import Vue from 'Vue';
import _ from 'lodash';
import addsite from './modals/addsite';
import SiteInfo from './SiteInfo';
import EditSite from './modals/EditSite';
import ServerInfo from './modals/ServerInfo';
import MaintenanceMode from './modals/MaintenanceMode';
import ManageGroups from './modals/ManageGroups';
import RemoveSite from './modals/RemoveSite';
import ReaddSite from './modals/ReAddSite';
import CreateBackup from './protect/CreateBackup';

import DownIcon from '../assets/down.svg';
import TickIcon from '../assets/tick.svg';
import MagnifierIcon from '../assets/lens.svg';
import GroupIcon from '../assets/groups.svg';
import InfoIcon from '../assets/info.svg';

import EmptyPlaceholder from './Common/EmptyPlaceholder';
import LoadingPlaceholder from '../assets/loadingplaceholder.svg';

export default {
  name: 'sidebar',
  props: ['isLoading'],
  data() {
    return {
      searchText: '',
      selectedGroupName: 'All Sites',
      currentSite: {},
      popoverMap: {},
      contentHoverMap: {},
      serverURL: window.serverURL,
      placeholderProps: {
        text: () => {
          return `Bummer, there are no websites that match. Try typing fewer characters.`;
        },
        type: 'neutral'
      }
    };
  },
  components: {
    addsite,
    SiteInfo,
    EditSite,
    ServerInfo,
    MaintenanceMode,
    ManageGroups,
    DownIcon,
    MagnifierIcon,
    GroupIcon,
    InfoIcon,
    TickIcon,
    RemoveSite,
    LoadingPlaceholder,
    ReaddSite,
    EmptyPlaceholder,
    CreateBackup
  },
  mounted() {
    // this.serverInfo(this.sites[0]);
    // this.openManageGroups();
  },
  computed: {
    sites() {
      let groupSites = _.values(this.$store.getters.getSitesByIdGroupId);
      let sites = groupSites.filter(site => {
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
      return _.sortBy(sites, 'name');
    },
    selectedSitesCount() {
      return this.$store.getters.selectedSitesCount;
    },
    groups() {
      return this.$store.getters.getGroups;
    },
    appInfo() {
      return this.$store.getters.getAppInfo;
    }
  },
  watch: {
    groups(newGroups) {
      let currentGroupId = this.$store.getters.getCurrentGroupId;
      if (currentGroupId == 'all') {
        return;
      }
      let index = _.findIndex(newGroups, { groupID: currentGroupId });
      if (index === -1) {
        this.selectGroup({ groupID: 'all' });
      }
    }
  },
  methods: {
    toggleSite(site, isSelected) {
      this.$store.commit({
        type: 'SELECT_SITE',
        site: site,
        value: isSelected
      });
    },
    selectAll(groups) {
      this.$store.commit({
        type: 'SELECT_SITES',
        value: true
      });
    },
    selectNone(groups) {
      return this.$store.commit({
        type: 'SELECT_SITES',
        value: false
      });
    },
    openAdminInNewTab() {
      let cacheValue = Date.now();
      window.open(
        `${window.serverURL}?action=loadSite&siteID=${
          this.currentSite.siteID
        }&cache=${cacheValue}`,
        '_blank'
      );
    },
    selectGroup(group) {
      if (group.groupID === 'all') {
        this.selectedGroupName = 'All Sites';
      } else {
        this.selectedGroupName = group.name;
      }
      this.$store.commit({
        type: 'SET_CURRENT_GROUP',
        value: group.groupID
      });
    },
    setPopoverMap(siteID, value) {
      Vue.set(this.popoverMap, siteID, value);
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    },
    setContentHoverMap(siteID) {
      this.contentHoverMap[siteID] = true;
    },
    closePopover(siteID) {
      this.contentHoverMap[siteID] = false;
      this.$root.$emit('bv::hide::popover', 'popover_' + siteID);
    },
    processAction(payload) {
      this.$root.$emit('bv::hide::popover');
      switch (payload.action) {
        case 'edit':
          this.editsite(payload.site);
          break;
        case 'serverInfo':
          this.serverInfo(payload.site);
          break;
        case 'maintenanceMode':
          this.maintananceMode(payload.site);
          break;
        case 'viewBackups':
          this.viewBackups(payload.site);
          break;
        case 'backupNow':
          this.backupNow(payload.site);
          break;
        case 'reloadData':
          this.sendReloadData(payload.site);
          break;
        case 'removeSite':
          this.removeSite(payload.site);
          break;
        case 'reAddSite':
          this.reAddSite(payload.site);
          break;
      }
    },
    editsite(site) {
      this.currentSite = site;
      this.$refs.editsite.$refs.editsitemodal.show();
    },
    serverInfo(site) {
      this.currentSite = site;
      this.$refs.serverinfo.$refs.serverinfomodal.show();
    },
    maintananceMode(site) {
      this.currentSite = site;
      this.$refs.maintanancemode.$refs.maintanancemodemodal.show();
    },
    openManageGroups($event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
      this.$refs.managegroups.$refs.managegroups.show();
    },
    showPopover(siteID) {
      this.$root.$emit('bv::hide::popover');
      this.$root.$emit('bv::show::popover', 'popover_' + siteID);
    },
    hidePopover(siteID) {
      setTimeout(() => {
        if (!this.contentHoverMap[siteID]) {
          this.$root.$emit('bv::hide::popover', 'popover_' + siteID);
        }
      }, 300);
    },
    removeSite(site) {
      this.currentSite = site;
      this.$refs.removesite.$refs.removesite.show();
    },
    reAddSite(site) {
      this.currentSite = site;
      this.$refs.readdsite.$refs.reAddSite.show();
    },
    viewBackups(site) {
      this.selectNone();
      this.$store.commit({
        type: 'SELECT_SITE2',
        site: site,
        value: true
      });
      this.$router.push({ name: 'Manage', params: { slug: 'backups' } });
    },
    backupNow(site) {
      this.currentSite = site;
      this.$refs.createBackup.$refs.createBackupModal.show();
    },
    sendReloadData(site) {
      let payload = {};
      payload.action = 'getStats';
      payload.args = {
        siteIDs: [site.siteID]
      };
      payload.requiredData = {
        getSites: 1,
        getHistoryPanelHTMLV3: 1,
        getPluginsAndThemesV3: 1,
        getGroupsSitesV3: 1,
        getSitesUpdatesV3: 1,
        getSitesBackupsV3: 1,
        getClientUpdateAvailableSiteIDs: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.$store.commit('SET_STATE_VARIABLE', {
          variable: 'currentReloadActionID',
          value: response.actionResult.actionID
        });
      });
    }
  }
};
</script>

<style scoped>
.accordion-icon {
  position: absolute;
  top: 6px;
  right: 0;
  width: 50px;
}
.site-dropdown {
  width: 100%;
}
.site-dropdown >>> button {
  width: 100%;
  text-align: left;
  color: black;
  background: white;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue